module.exports = __webpack_public_path__ + "img/xls-icon.27270f9a.png";